import { AxiosResponse } from 'axios'
import { buildServerApiUrl, getTenantId } from "../../Api/urls"
import { IUseAxiosOptions, useAxiosGet, useAxiosPost } from '../../Api/useAxios'

export interface IUpsertPowerBiSubscription {
    TenantId: string,
    SubscriptionId: number,
    SubscribeName: string,
    RecipientMailId: string,
    ReportId: string,
    ReportTypeFormat: string,
    SubscriptionStartDate: Date,
    Frequency: string,
    Status: boolean
    Timezone: string,
    ReportUrl: string,
    WeekOfFrequency: string | null,
    MonthOfFrequency: string | null,
    author:string
}

export type IUpsertSubscription = Omit<IUpsertPowerBiSubscription, "TenantId">

type TUpsertPowerBiSubscription = [
    (payload: IUpsertSubscription) => Promise<AxiosResponse<any> | undefined>,
    {
        posting: boolean,
        status?: string | number,
        errors: any[],
    }
]

export const upsertSubscribeUrl = `${buildServerApiUrl("PowerBi.UpsertSubscription").toString()}`
export const upsertPowerBiSubscription = (
    options?: IUseAxiosOptions<IUpsertPowerBiSubscription>
): TUpsertPowerBiSubscription => {

    const [upsert, { posting, status, errors }] = useAxiosPost<IUpsertPowerBiSubscription>(
        upsertSubscribeUrl, {}, options
    )

    const upsertSubscription = async (payload: IUpsertSubscription) => {
        const res = await upsert({ ...payload, TenantId: getTenantId() })
        return res
    }

    return [upsertSubscription, { posting, status, errors }]
}

export interface IGetSubscription {
    subscriptionId: number,
    subscriptionName: string,
    reportId: string,
    recipients: string,
    frequency: any,
    reportTypeFormat: string,
    subscriptionStartDate: Date,
    timezone: string,
    weekOfFrequency: string | null,
    monthOfFrequency: string | null,
    author:string
}

type TUseGetSubscriptionDetails = [
    {
        SubscriptionDetails: IGetSubscription[],
        loading: boolean,
        status?: string | number,
        errors: any[],
    },
    () => Promise<AxiosResponse<any> | undefined>
]


export const useGetSubscriptionDetails = (toggle:boolean): TUseGetSubscriptionDetails => {
    if(toggle === false) {
        return [{ SubscriptionDetails: [], loading: false, status: 1, errors: [] }, async () => { return undefined }]
    }
    const getSubscriptionUrlPath = `${buildServerApiUrl("PowerBi.GetSubscriptionDetails").toString()}/${getTenantId()}`
    const [{ data, loading, errors, status }, reFetchData] = useAxiosGet(
        getSubscriptionUrlPath
    )
    let SubscriptionDetails
    if (data) {
        SubscriptionDetails = data
    }
    return [{ SubscriptionDetails, loading, status, errors }, reFetchData]
}

interface IDeleteSubscriptionPayload {
    subscriptionId: number
}

type IDeleteSubscription = Omit<IDeleteSubscriptionPayload, "customerKey">

type TUseDeleteSubscription = [
    (payload: IDeleteSubscription) => Promise<AxiosResponse<any> | undefined>,
    {
        posting: boolean,
        status?: string | number,
        errors: any[],
    }
]

const deleteSubscriptionUrl = `${buildServerApiUrl("PowerBi.DeleteSubscription").toString()}`
export const useDeleteSubscription = (
    options?: IUseAxiosOptions<IDeleteSubscriptionPayload>
): TUseDeleteSubscription => {
    const [execute, { posting, status, errors }] = useAxiosPost<IDeleteSubscriptionPayload>(
        deleteSubscriptionUrl, {}, options
    )

    const clear = async (payload: IDeleteSubscription) => {
        const res = await execute({ ...payload})
        return res
    }

    return [clear, { posting, status, errors }]
}
